import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowTrendDown = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m17,14l-7.293-7.293c-.391-.391-1.024-.391-1.414,0l-2.586,2.586c-.391.391-1.024.391-1.414,0l-2.293-2.293", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", "data-color": "color-2" }),
        React.createElement("polyline", { points: "17 7 17 14 10 14", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=IconArrowTrendDown.js.map